import { render, staticRenderFns } from "./CustomLinkList.vue?vue&type=template&id=1947598f&scoped=true&"
import script from "./CustomLinkList.vue?vue&type=script&lang=js&"
export * from "./CustomLinkList.vue?vue&type=script&lang=js&"
import style0 from "./CustomLinkList.vue?vue&type=style&index=0&id=1947598f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947598f",
  null
  
)

export default component.exports